var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex jc-center ai-center h-100 p-relative min-height overflow-y-overlay"},[_c('div',{staticClass:"design-main d-flex"},[_c('div',{staticClass:"w-100 px-16 py-5"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }